import groupsPermissions from "./groups_permissions.json"

export default function hasPermission(permission, ticket_type = "global") {

  if (localStorage.getItem('connected') !== 'true')
    return false;

  if (localStorage.getItem('is_superuser') === 'true')
    return true;

  let groups = localStorage.getItem('groups');

  if (!groupsPermissions[ticket_type]) {
    return false;
  }

  const typeGroups = groupsPermissions[ticket_type];

  if (groups != null) {
    groups = groups.split(',');

    for (let i = 0; i < groups.length; i++) {
      const groupName = groups[i];

      const permissions = typeGroups[groupName];

      if (permissions && permissions.includes(permission)) {
        return true;
      }
    }
  }

  return false;
}